import {
  createIncomeOrExpenseAddRoute,
  INCOME_OR_EXPENSE_LIST,
  LP_CAPITAL_ACTION_CREATE,
} from 'adminConstants/routes';
import SuccessPage from 'components/new/SuccessPage';
import { IncomeOrExpenseType } from 'further-types/lp/income-and-expenses';
import { FundingSource } from 'further-types/lp/investment';
import { useParams, useLocation } from 'react-router-dom';

const Success: React.FC = () => {
  const { type } = useParams<{ type?: IncomeOrExpenseType }>();
  const location = useLocation<{ fundingSource?: FundingSource }>();
  const fundingSource = location.state?.fundingSource;

  const label = type === IncomeOrExpenseType.Income ? 'Income' : 'Expense';

  const isGeneralCapital =
    type === IncomeOrExpenseType.Expense &&
    fundingSource === FundingSource.GeneralCapitalOnAccounts;

  const content = isGeneralCapital ? (
    <>
      The <i>General ledger</i> has been updated and this expense has been
      funded from general capital on accounts.
    </>
  ) : type === IncomeOrExpenseType.Income ? (
    <>
      The <i>General ledger</i> has been updated and this income will be
      available for distribution in the next capital action.
    </>
  ) : (
    <>
      The <i>General ledger</i> has been updated and this expense will be
      available to call in the next capital action.
    </>
  );

  return (
    <SuccessPage
      title={`${label} has been added successfully`}
      content={content}
      primaryButton={
        isGeneralCapital
          ? {
              label: 'View all incomes and expenses',
              link: INCOME_OR_EXPENSE_LIST,
            }
          : { label: 'Process capital call', link: LP_CAPITAL_ACTION_CREATE }
      }
      tertiaryButton={{
        label: 'Add another income or expense',
        link: createIncomeOrExpenseAddRoute(),
      }}
    />
  );
};

export default Success;
